import React, { FunctionComponent, ReactNode } from 'react';

import { usePageMeta } from '../../hooks';

export const QR_CODE_SLUG = '/qrcode';

const IsQRCode: FunctionComponent = ({
  children,
}: {
  children?: ReactNode;
}) => {
  const { currentUrl } = usePageMeta();
  const isQRCode = currentUrl?.endsWith(QR_CODE_SLUG);

  return isQRCode ? <>{children}</> : null;
};

export default IsQRCode;
